// DS3.8
import React from 'react';
import c from 'classnames';
import readableFileSize from 'filesize';
import SmartAttachmentIcon from '../Icons/SmartAttachment';
import { IconSize } from '../Icons/IconWrap';

import s from './AttachedFile.scss';

export interface Props {
  name: string;
  size: File['size'];
  type: File['type'];
  width?: number;
  height?: number;
  previewUrl?: string;
  preview?: React.ReactNode;
  middleSlot?: React.ReactNode;
  rightSlot?: React.ReactNode;
  className?: string;
  /** word wrap long names instead of truncating them? */
  wrapLongNames?: boolean;
  customName?: boolean;
}

const AttachedFile: React.FC<Props> = ({
  className,
  name,
  size,
  type,
  width,
  height,
  previewUrl,
  preview,
  middleSlot,
  rightSlot,
  wrapLongNames,
  customName,
}) => {
  const nameParts = name.split('.');
  const extension = nameParts.pop();
  const nameWithoutExtension = nameParts.join('.');

  const renderIcon = () => {
    if (preview) {
      return preview;
    }
    if (previewUrl) {
      return (
        <div className={s['preview-icon']} style={{ backgroundImage: `url(${previewUrl})` }} />
      );
    }

    return <SmartAttachmentIcon className={s['icon']} size={IconSize.SMALLER} type={type} />;
  };

  return (
    <div className={c(s['root'], wrapLongNames && s['word-wrap'], className)}>
      {renderIcon()}
      {customName ? (
        <div className={s['filename']} title={name}>
          <span className={s['name']}>{name}</span>
        </div>
      ) : (
        <div className={s['filename']} title={nameWithoutExtension}>
          <span className={s['name']}>
            {nameWithoutExtension}
            {extension ? '.' : ''}
          </span>
          <span className={s['extension']}>{extension}</span>
        </div>
      )}
      <div className={s['middle-slot']}>
        {middleSlot || (
          <>
            {readableFileSize(size)}
            {width && height ? ` - ${width} x ${height}` : null}
          </>
        )}
      </div>
      <div className={s['right-slot']}>{rightSlot}</div>
    </div>
  );
};
AttachedFile.displayName = 'AttachedFile';

export default AttachedFile;
